exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ScreenEditor[data-v-3c70093f] {\n  table-layout: fixed;\n  display: table;\n  width: 100%;\n  height: 100%;\n}\n.ScreenEditor_Container[data-v-3c70093f] {\n    height: 100%;\n    display: table-row;\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAF0lEQVR4AWP4DwVvoWCgBGAMmMQACQAAuK72AWHjK4wAAAAASUVORK5CYII=);\n}\n", ""]);

// exports
